<template>
  <div>
    <b-notification
      v-for="(error, index) in errors"
      v-bind:key="index"
      type="is-danger"
      aria-close-label="Close notification"
      role="alert"
      >{{ error.message }}</b-notification
    >
    <div v-if="cognitoUser">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(setNewPassword)">
          <p>{{ $t('Es necesario que establezca una nueva contraseña') }}</p>
          <ValidationProvider
            name="Contraseña"
            rules="required|min:8|verify_password|password:@confirm"
            v-slot="{ errors }"
          >
            <b-field :label="$t('Contraseña')">
              <b-input
                v-model="form.password"
                type="password"
                password-reveal
                name="password"
              />
            </b-field>
            <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
          </ValidationProvider>

          <ValidationProvider
            name="confirm"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field :label="$t('Confirmar Contraseña')">
              <b-input
                v-model="form.confirmation"
                type="password"
                password-reveal
              />
            </b-field>
            <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
          </ValidationProvider>

          <b-field style="text-align: center;">
            <button
              native-type="submit"
               class="button is-pink is-full-w"
              :class="{ 'is-loading': isLoading }"
            >
              {{ $t('Cambiar contraseña') }}
            </button>
          </b-field>
        </form>
      </ValidationObserver>
    </div>
    <div v-else>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(signIn)">
          <ValidationProvider
            name="Email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <b-field :label="$t('Email')">
              <b-input v-model="form.username" />
            </b-field>

            <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
          </ValidationProvider>
          <ValidationProvider
            name="Contraseña"
            rules="required"
            v-slot="{ errors }"
          >
            <b-field :label="$t('Contraseña')">
              <b-input
                v-model="form.password"
                type="password"
                name="password"
                password-reveal
              />
            </b-field>
            <p v-show="errors.length" class="help is-danger">{{ errors[0] }}</p>
          </ValidationProvider>

          <b-field style="text-align: center;">
            <button
              native-type="submit"
              class="button is-pink is-full-w"
              :class="{ 'is-loading': isLoading }"
            >
              {{ $t('Login') }}
            </button>
          </b-field>
          <b-field>
            <div class="control" style="margin-top: 10px;">
              <p>
                <a v-on:click="goToContact" class="customLink is-size-6"
                  >{{ $t('Registrarme') }} |</a
                >
                <a v-on:click="goToRecover" class="customLink is-size-6">{{
                  $t('He olvidado mi contraseña')
                }}</a>
              </p>
            </div>
          </b-field>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'

import { required, alpha, numeric, email, min } from 'vee-validate/dist/rules'

extend('verify_password', value => {
  var strongRegex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$()%^&*])(?=.{8,})'
  )
  if (strongRegex.test(value)) {
    return true
  }

  return 'La contraseña debe contener al menos un dígito, un caracter especial y una mayúscula'
})

extend('min', {
  ...min
})

extend('required', {
  ...required
})

extend('alpha', {
  ...alpha
})

extend('numeric', {
  ...numeric
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    console.log(value)
    console.log(target)
    return value === target
  },
  message: 'Las contraseñas no coinciden'
})

extend('email', {
  ...email
})

export default {
  name: 'SignIn',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      cognitoUser: null,
      form: {
        username: '',
        password: '',
        confirmation: ''
      }
    }
  },
  computed: {},
  methods: {
    updateLocale(val) {
      this.changeLocale(val)
      this.$i18n.locale = val
    },
    goToSignUp() {
      this.$router.push({ name: 'sign-up' })
    },
    goToRecover() {
      this.$router.push({ name: 'forgot' })
    },
    goToContact() {
      window.location.href = 'https://myneofintech.com/myneofintech/contacto/'
    },
    async setNewPassword() {
      let self = this
      const password = self.form.password
      try {
        self.isLoading = true
        await Auth.completeNewPassword(self.cognitoUser, password)
          .then(function() {
            self.cognitoUser = null
            AmplifyEventBus.$emit('authState', 'signedIn')
          })
          .catch(err => self.errors.push(err))
          .then(function() {
            self.isLoading = false
          })
      } catch (err) {
        self.error = err.message
        self.isLoading = false
      }
    },
    async signIn() {
      let self = this
      const { username, password } = this.form
      try {
        self.isLoading = true
        await Auth.signIn(username, password)
          .then(function(resp) {
            self.cognitoUser = resp
            if (self.cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
              self.form.password = ''
            } else {
              AmplifyEventBus.$emit('authState', 'signedIn')
            }
          })
          .catch(err => {
            self.errors.push(err)
            console.log(err)
          })
          .then(function() {
            self.isLoading = false
          })
      } catch (err) {
        console.log(err)
        self.errors.push(err)
        self.isLoading = false
      }
    }
  }
}
</script>
